/**
 * 插件git地址：https://github.com/baianat/vee-validate
 * -- 语法：
 *    <input v-validate="'required|min:6'" type="password" name="password" data-vv-as="密码">
 *    <input v-validate="{ required: true, min: 6 }" type="password" name="password">
 * -- 插件内嵌规则：https://baianat.github.io/vee-validate/guide/rules.html
 * -- 自定义规则
 * -- 本地化错误提示
 * -- flags：记录input的一些状态
 * -- 校验触发的事件
 *    Vue.use(VeeValidate, { events: 'change|custom' }); //更改全局触发事件
 *    <input name="field" v-validate.disable="'required'" data-vv-validate-on="change|custom"> // 可指定事件触发方法和禁止触发
 * -- 动态输入框
 */
import VeeValidate, { Validator } from 'vee-validate'
import ZhCN from 'vee-validate/dist/locale/zh_CN'
// 字典
// const dictionary = {
//   en: {
//     messages: {
//       isIDCard: (field) => `${field} not a valid ID`
//     }
//   },
//   zh_CN: {
//     messages: {
//       isIDCard: (field) => `${field} 不是有效的身份证`
//     }
//   }
// }
// Validator.localize(dictionary)

Validator.extend('isIDCard', {
  getMessage (filed, args) {
    return '不是有效的身份证'
  },
  validate (value, args) {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    return /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(value)
  }
})

Validator.localize(ZhCN.name, ZhCN)
export default VeeValidate



// WEBPACK FOOTER //
// ./src/plugins/validator/rules.js